const DEFAULT_LABEL_KEY = "label";
const DEFAULT_VALUE_KEY = "value";
const DEFAULT_ICON_KEY = "icon";
const DEFAULT_THUMBNAIL_KEY = "thumbnail";

export { DEFAULT_LABEL_KEY, DEFAULT_VALUE_KEY, DEFAULT_ICON_KEY, DEFAULT_THUMBNAIL_KEY };
